import InactiveProducts from './InactiveProducts';

export default InactiveProducts;
